/**
 * Atur ulang kata sandi — bagian MURNI.
 *
 * ADA KARENA malam 17 Agustus 2026, sehari sebelum onboarding pilot: seseorang tidak dapat masuk,
 * dan layar masuk Workforce tidak menawarkan jalan keluar apa pun. Satu-satunya jalan pulang ada
 * di produk LAIN (CRM) — yang tidak pernah dibuka pekerja lapangan, dan tidak pernah disebut di
 * mana pun pada layar yang sedang menolaknya.
 *
 * Kurir yang lupa kata sandinya pada pagi hari tidak akan menemukan CRM. Ia akan menelepon
 * atasannya, dan absensinya hilang untuk hari itu.
 */

/** Sama dengan aturan CRM. Diselaraskan sengaja: satu identitas, satu syarat. */
export const MIN_PASSWORD_LENGTH = 8;

/**
 * Satu masalah pada satu waktu, bukan daftar.
 *
 * Menampilkan seluruh pelanggaran sekaligus membuat orang memperbaiki semuanya sambil menebak
 * mana yang benar-benar menghalangi. Null berarti boleh dikirim.
 */
export function passwordProblem(password: string, confirmation: string): string | null {
  if (password.length === 0) return 'Kata sandi baru belum diisi.';
  if (password.length < MIN_PASSWORD_LENGTH) {
    return `Kata sandi minimal ${MIN_PASSWORD_LENGTH} karakter.`;
  }
  // Diperiksa SETELAH panjang: memberi tahu "tidak sama" pada kata sandi yang toh akan ditolak
  // karena terlalu pendek membuat orang memperbaiki hal yang salah lebih dulu.
  if (confirmation.length === 0) return 'Ulangi kata sandi barunya.';
  if (password !== confirmation) return 'Kedua kata sandi belum sama.';
  return null;
}

/** Email kosong ditolak di sini, bukan dibiarkan menjadi permintaan yang pasti gagal. */
export function emailProblem(email: string): string | null {
  const bersih = email.trim();
  if (bersih.length === 0) return 'Email belum diisi.';
  // Sengaja longgar: penyaringan ketat di sisi klien menolak alamat sah yang jarang dipakai,
  // dan server tetap memvalidasinya sendiri.
  if (!bersih.includes('@') || bersih.startsWith('@') || bersih.endsWith('@')) {
    return 'Email tidak terlihat benar.';
  }
  return null;
}

/**
 * Apakah halaman ini dibuka DARI tautan pemulihan kata sandi.
 *
 * Supabase memakai dua bentuk yang berbeda tergantung alur proyeknya:
 *   - implicit : `#access_token=…&type=recovery`
 *   - PKCE     : `?code=…`
 *
 * Keduanya diperiksa. Menebak salah satu saja membuat tautan yang sah mendarat di layar masuk
 * biasa — orangnya mengira tautannya rusak, padahal ia berhasil.
 *
 * `error` pada tautan (mis. kedaluwarsa) juga dihitung sebagai masuk lewat pemulihan: layar
 * pemulihanlah yang harus menjelaskan kegagalannya, bukan layar masuk yang diam saja.
 */
export function isRecoveryEntry(search: string, hash: string): boolean {
  const cariParam = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const hashParam = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);

  if (hashParam.get('type') === 'recovery') return true;
  if (cariParam.get('type') === 'recovery') return true;
  if (cariParam.has('code')) return true;
  if (hashParam.has('error') || cariParam.has('error')) return true;
  return false;
}
